import React from 'react';
import { styled } from 'theme';

export type RemoveFilterButtonProps = {
  onClick?: (event: any) => void;
} & React.HTMLAttributes<HTMLButtonElement>;

function RemoveFilterButton({
  className,
  onClick,
  title = 'Remove filter',
  ...props
}: RemoveFilterButtonProps) {
  return (
    <button
      {...props}
      data-testid="remove-filter"
      type="button"
      onClick={onClick}
      className={className}
      title={title}
    >
      -
    </button>
  );
}

export default styled(RemoveFilterButton)((props) => ({
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: props.theme.spacing(1),
  height: props.theme.spacing(1),
  background: props.theme.palette.primary.main,
  ...props.theme.typography.smallMedium,
  color: props.theme.palette.onPrimary.main,
  borderRadius: '50%',
  cursor: 'pointer',
}));
